import { useEffect } from 'react';

const SCRIPT_ID = 'page-structured-data';

/**
 * Injecte un bloc JSON-LD dans <head> pour la page courante.
 * Remplace le précédent à chaque changement de route.
 */
export const StructuredData = ({ data }) => {
  useEffect(() => {
    // Supprime l'éventuel script précédent
    const existing = document.getElementById(SCRIPT_ID);
    if (existing) existing.remove();

    // Crée le nouveau
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(SCRIPT_ID);
      if (el) el.remove();
    };
  }, [data]);

  return null;
};

/* ─── Helpers : schémas prêts à l'emploi ─────────────────────────────────── */

const BASE = 'https://lunetteriedurussey.fr';

export const breadcrumb = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  'itemListElement': items.map(({ name, path }, i) => ({
    '@type': 'ListItem',
    'position': i + 1,
    'name': name,
    'item': `${BASE}${path}`,
  })),
});

export const webpage = ({ name, description, path }) => ({
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': `${BASE}${path}#webpage`,
  'name': name,
  'description': description,
  'url': `${BASE}${path}`,
  'isPartOf': { '@id': `${BASE}/#business` },
  'inLanguage': 'fr-FR',
});
